{
  "appName": "DS V3 Playground",
  "entryFile": "./app-entry.jsx",
  "entryName": "ds-v3-playground",
  "rootUrl": "/ds-v3-playground",
  "productId": "63fa0a80-e79d-47e7-9cce-e03a8edb2535"
}
